import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import 'react-datepicker/dist/react-datepicker.css';
import { verifyEmail, isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setShowUserPopup, showMessage } from "../../../features/common";
import axios from "axios";
import { API_OK, API_201, API_403, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, navigateTo} from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import DateInput from '../../widgets/DateInput';
import CheckBox from '../../widgets/CheckBox';
import ImagePicker from '../../widgets/ImagePicker';


export function RegisterProvider() {
    const [state, setState] = useState({provider:{firstName: '', lastName: '', gender: null, dateOfBirth: null, email: '', password: '', avatar: null}, errors:{}, showImagePicker:false});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
            navigateTo(dispatch, navigate, '/home');
        }
        // eslint-disable-next-line
    },[]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"lang": getLang()}};
          
            const data = {firstName: state.provider.firstName.trim(), lastName: state.provider.lastName.trim(), gender: state.provider.gender, dateOfBirth: state.provider.dateOfBirth, email: state.provider.email.trim(), password: state.provider.password.trim(), avatar: state.provider.avatar};

            try {
                const reply = await axios.post(API_URL + '/providers', data, config);
                console.log(reply);
                if(reply.hasOwnProperty('status') && reply.status === API_201) {
                    const reply = await axios.post(API_URL + '/authprovider', data, config);
                    console.log(reply);
                    if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_201
                            && reply.data.hasOwnProperty('accessToken')){
                        dispatch(verifyEmail({token : reply.data.accessToken, userType:'provider'}));        
                        dispatch(setShowUserPopup({showUserPopup: true}));
                        navigate("/verify-email");
                    }
                }
            } catch (e) {
                if(e.response?.status === API_403) {
                    errorMessage = 'email_already_exists';
                } else if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        // console.log(id+'  '+value)
        delete state.errors[id];
        setState({
            ...state, 
            provider:{...state.provider,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const toggleImagePicker = () => {
        setState({
            ...state,
            showImagePicker: !state.showImagePicker,
        });
    };


    const setAvatarImage = (image) => {
        setState({
            ...state,
            showImagePicker: false,
            provider:{...state.provider,
                ['avatar']: image,
            },
        });

    }

    const validateForm = () => {
        const errors = {};
        if (!state.provider.firstName?.trim() /*|| state.firstName.trim().length < 4*/) {
            errors['firstName'] = 'first_name_error';
        }

        if (!state.provider.lastName?.trim()) {
            errors['lastName'] = 'last_name_error';
        }

        if (!(state.provider.dateOfBirth)) {
            errors['dateOfBirth'] = 'dote_of_birth_error';
        }

        if (!state.provider.email?.trim()) {
            errors['email'] = 'email_error';
        }

        if (!state.provider.password?.trim()) {
            errors['password'] = 'password_error';
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    return (
        <Frame>
            <div className='main main-provider-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.provider?<Background >
                            <div className='right-main-inner'>
                            {/* <form onSubmit={handleSubmit}> */}


                                <div className='center-div relative mt60'>
                                    <div className='center-div' onClick={()=>toggleImagePicker()}>
                                        <img src={state.provider.avatar?'/images/avatar.png':'/images/photo_upload.png'} className='avatar-border' alt=''/>
                                        <div className='avatar-div'>
                                            {state.provider.avatar && <img src={arrayBufferToBase64(state.provider.avatar)} className='avatar' alt=''/>}
                                        </div>
                                    </div>
                                </div>
                                <div className='image-picker'>
                                    {state.showImagePicker && 
                                        <ImagePicker title={t('choose_profile_picture')} onSelected={(image)=>setAvatarImage(image)} onCancel={()=>toggleImagePicker()} avatar={true}/>
                                    }
                                </div>

                                <div className='mt60'>
                                    <Input className={state.errors.firstName?"error":""} id="firstName" placeholder={t("first_name")} value={state.provider.firstName??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.firstName && <div className='mt5 error font-12'><Trans i18nKey={state.errors.firstName} /></div>}

                                <div className='mt30'>
                                    <Input className={state.errors.lastName?"error":""} id="lastName" placeholder={t("last_name")} value={state.provider.lastName??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.lastName && <div className='mt5 error font-12'><Trans i18nKey={state.errors.lastName} /></div>}

                                <div className='mt30 font-24 flex justify-content-space-between align-items-center ml5 mr5'>
                                    <CheckBox id='male' text={t('male')} value={state.provider.gender} onChange={(id) => change('gender', id)} />
                                    <CheckBox id='female' text={t('female')} value={state.provider.gender} onChange={(id) => change('gender', id)} />
                                    <CheckBox id='other' text={t('other')} value={state.provider.gender} onChange={(id) => change('gender', id)} />
                                </div>
                                <div className='mt25'>
                                    <DateInput id="dateOfBirth" placeholder={t("dote_of_birth")} value={state.provider.dateOfBirth} readOnly={true} onChange={(date) => change('dateOfBirth', date)} />
                                </div>
                                {state.errors.dateOfBirth && <div className='mt5 error font-12'><Trans i18nKey={state.errors.dateOfBirth} /></div>}

                                <div className='mt30'>
                                    <Input className={state.errors.email?"error":""} id="email" placeholder={t("email")} value={state.provider.email??''} onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.email && <div className='mt5 error font-12'><Trans i18nKey={state.errors.email} /></div>}

                                <div className='mt30'>
                                    <Input className={state.errors.password?"error":""} id="password" placeholder={t("password")} value={state.provider.password??''} type='password' onChange={(e) => handleChange(e)}/>
                                </div>
                                {state.errors.password && <div className='mt5 error font-12'><Trans i18nKey={state.errors.password} /></div>}

                                <div className='button mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("next")}</div> </div>
                            </div>
                            </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}